import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import GenericPlanner from "./components/GenericPlanner/GenericPlanner";
import useGenericPlanner from "./hooks/useGenericPlanner";
import { RootState } from "../../../redux/store";
import PageHeader from "components/Common/PageHeader";
import CustomAlert from "components/Common/ui/CustomAlert";
import { all_routes } from "router/all_routes";
import Loader from "components/Common/loader";


const TeacherRoutinePage = () => {
  const { t } = useTranslation();
  const user = useSelector((state: RootState) => state.authSlice.user);
  const teacherIds = useMemo(() => user?.roleId ? [user?.roleId] : [], [user?.roleId]);
  const {
    data: plannerData,
    isLoading: plannerLoading,
    error: plannerError
  } = useGenericPlanner({ role: "teacher", teacherIds });

  const breadcrumbItems = [
    { label: "dashboard", path: all_routes.dashboard },
    { label: "my_routine", active: true },
  ];

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader
          title={t("my_routine")}
          breadcrumbItems={breadcrumbItems}
        />
        <div>
          <div>
            {plannerLoading ? (
              <div className="d-flex justify-content-center my-5">
                <Loader />
              </div>
            ) : plannerError ? (
              <CustomAlert message={plannerError} type="error" showIcon className="mb-3" />
            ) : !teacherIds.length ? (
              <CustomAlert
                message={t("alert.teacher_not_found.message")}
                description={t("alert.teacher_not_found.description")}
                type="warning"
                showIcon
              />
            ) : (
              <div className="">
                <GenericPlanner role="teacher" data={plannerData} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherRoutinePage;